import axios from 'axios'
import router from '@/router/index'
import { Notice } from 'iview';

axios.defaults.timeout = 60000
axios.interceptors.request.use(config => {
    let arr=[
        "api/pub/send_sms",
        "api/facilitator/login",
        "api/facilitator/reg",
        "api/facilitator/reset_pwd",
    ]
    if( !arr.includes(config.url) ){
        if(!localStorage.getItem('facilitator_id')  || !localStorage.getItem('token')){
            logout()
            Notice.error({
                title: '派智知识产权平台',
                desc: '登录超时'
            })
            return 
        }
        if(!config.data) config.data={}

        config.data.facilitator_id=localStorage.getItem('facilitator_id')
        config.headers['http-x-token'] = localStorage.getItem('token') || ''
   
    }
    return config;
},
err => {
    Notice.error({
        title: '派智知识产权平台',
        desc: '客户端通讯出错'
    })
});

axios.interceptors.response.use(res => {
    if(!res.data){  //没有任何数据
        Notice.error({
            title: '派智知识产权平台',
            desc: '服务器没有响应'
        })
        return  
    }
    const back=res.data
    switch(back.code){
        case 2:
        case 0:
            return back
        case 1:   
            Notice.error({
                title: '派智知识产权平台',
                desc: back.msg || '业务数据异常'  
            })
            break
        case 401:
        case 402:
        case 403:
            localStorage.clear()
            router.push('login')
            Notice.error({
                title: '派智知识产权平台',
                desc: '登录超时，请重新登录'
            })
            break
        default:
            Notice.error({
                title: '派智知识产权平台',
                desc: back.msg ||'平台数据异常' 
            })
            break 
    }
},
error => {
    Notice.error({
        title: '派智知识产权平台',
        desc: '无法连接服务器'
    })
    new Error(error)
});


const comp_EXP= function(){  //验证是否过期 jwt是否存在
    let now=Number(Date.parse(new Date()).toString().substr(0,10))
    let exp=localStorage.getItem('expTime')
     if( localStorage.getItem('token') && now < exp ){
        if( (exp-now) <600 ){
            axios.post('api/facilitator/refresh_token',{token:localStorage.getItem('token')})
            .then(res=>{
                if(res.data.code==0){
                    localStorage.setItem('token',res.data.token)
                    localStorage.setItem('expTime',res.data.exp)
                }
            })
        }
        return true;
     }
    else{
        localStorage.clear();
        localStorage.setItem('step',true)
        return false;
    }
}
const logout=function(){
    localStorage.clear()
    localStorage.setItem('step',true)
    router.push('login')
}
const sendMSG=function (data) {
    data.type ='服务商端'	
    return axios.post('api/pub/send_sms', data)
}
const login = function (data) {
    return axios.post('api/facilitator/login', data)
}
const register = function (data) {
    return axios.post('api/facilitator/reg', data)
}
const forget_pwd = function (data) {
    return axios.post('api/facilitator/reset_pwd', data)
}
const getTasks = function (data) { //任务大厅
    return axios.post('api/facilitator/tasks', data) 
}
const applyTask = function (data) { //申请任务
    return axios.post('api/facilitator/apply_task', data) 
}
const cancelApply = function (data) { //取消申请任务
    return axios.post('api/facilitator/cancel_apply', data) 
}
const indexLink = function (data) { //首页接口
    return axios.post('api/facilitator/index', data) 
}
const myTask = function (data) { //首页接口
    return axios.post('api/facilitator/mytask', data) 
}
const caseDetail = function (data) { //案件详情
    return axios.post('api/facilitator/case_detail', data) 
}
const caseFiles = function (data) { //相关文件
    return axios.post('api/facilitator/case_files', data)  
}
const balance = function (data) { //收支明细
    return axios.post('api/facilitator/balance', data)  
}
const applyWithdraw = function (data) { //收支明细
    return axios.post('api/facilitator/apply_withdraw', data)  
}
const userinfo = function (data) { //账户信息
    return axios.post('api/facilitator/userinfo', data)  
}
const caseNaming = function (data) {  //账户信息
    return axios.post('api/facilitator/case_naming', data)  
}
const caseWrite = function (data) {  //撰写案件
    return axios.post('api/facilitator/case_write', data)  
}
const caseCorrection = function (data) { //撰写案件
    return axios.post('api/facilitator/case_correction', data)  
}
const caseReply = function (data) {  //答复案件
    return axios.post('api/facilitator/case_reply', data)  
}
const editInfo = function (data) { //案件详情
    return axios.post('api/facilitator/editInfo', data)  //账户信息
}
const getMessage = function (data) { //消息
    return axios.post('api/facilitator/message', data)  //消息
}
const digg_tasks = function (data) {
    return axios.post('api/facilitator/digg_tasks', data) 
}
const apply_digg_task = function (data) {
    return axios.post('api/facilitator/apply_digg_task', data) 
}
const cancel_digg_apply = function (data) {
    return axios.post('api/facilitator/cancel_digg_apply', data)  //挖掘的任务取消
}
const my_digg_task = function (data) {
    return axios.post('api/facilitator/my_digg_task', data)  //我的挖掘任务
}
const digg_case_detail = function (data) {
    return axios.post('api/facilitator/digg_case_detail', data)
}
const digg_case_naming = function (data) {
    return axios.post('api/facilitator/digg_case_naming', data)
}

const getMSG_num = function () { 
    let data={ user_type:'服务商' } 
    return axios.post('api/facilitator/unread',data)
}
const upload_file = function (data) { 
    data.append("facilitator_id", localStorage.getItem('facilitator_id'));
    return axios.post('api/facilitator/upload_file',data,{headers: {"Content-Type": "multipart/form-data"},timeout:300000})  
}
const down_casefile = function (data) {
    return axios.post('api/facilitator/down_casefile', data)
}
const case_correction_v2 = function (data) {
    return axios.post('api/facilitator/case_correction_v2', data)
}
const case_reply_v2 = function (data) {
    return axios.post('api/facilitator/case_reply_v2', data)
}
const case_remark = function (data) {
    return axios.post('api/facilitator/case_remark', data)
}
const down_tech_doc=function(data){ 
    return axios.post('/api/pub/down_tech_doc',data);
}
const getConfig=function(data){ 
    return axios.post('/api/pub/config',data);
}
export  {
    logout,
    sendMSG,
    comp_EXP,
    login,
    register,
    forget_pwd,
    getTasks,
    cancelApply,
    indexLink,
    applyTask,
    caseDetail,
    caseFiles,
    balance,
    applyWithdraw,
    userinfo,
    caseNaming,
    caseWrite,
    caseCorrection,
    caseReply,
    myTask,
    editInfo,
    getMessage,
    digg_tasks,
    apply_digg_task,
    cancel_digg_apply,
    my_digg_task,
    digg_case_detail,
    digg_case_naming,
    getMSG_num,
    upload_file,
    down_casefile,
    case_correction_v2,
    case_reply_v2,
    case_remark,
    down_tech_doc,
    getConfig
}



// WEBPACK FOOTER //
// ./src/assets/api.js